import { withSvgIcon } from './withSvgIcon';

export const Plus = withSvgIcon(
  <>
    <path
      d="M19 12L5 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M12 19L12 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
